import { lazy } from 'react';

const Sportsbook = lazy(() => import(/* webpackChunkName: "sportsbook" */ './sportsbook'));

export default Sportsbook;
